const HASH_RADIX = 36;
const HASH_LENGTH = 5;
const HASH_SPACE = HASH_RADIX ** HASH_LENGTH;

/**
 * Creates a compact, deterministic hash for stable identifiers.
 *
 * The output is always five lowercase base-36 characters.
 *
 * @param {string} value
 * @returns {string}
 */
export default function getStableHash(value) {
  const normalizedValue = value.normalize('NFKC').trim();
  let hash = 2166136261;

  for (let index = 0; index < normalizedValue.length; index += 1) {
    // eslint-disable-next-line no-bitwise -- FNV-1a requires an XOR operation
    hash ^= normalizedValue.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  // eslint-disable-next-line no-bitwise -- convert the signed hash to uint32
  const compactHash = (hash >>> 0) % HASH_SPACE;
  return compactHash.toString(HASH_RADIX).padStart(HASH_LENGTH, '0');
}
